.close {
    position: fixed;
    top: 1rem;
    right: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    cursor: pointer;
    z-index: 1101;

    svg {
        width: 1rem;
        height: 1rem;
    }
}

.overlay {
    position: fixed;
    inset: 0;
    z-index: 1099;
}

.content {
    position: fixed;
    z-index: 1100;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    background-color: var(--color-white);
    overflow: auto;
    transition: transform 0.3s;
    -webkit-overflow-scrolling: touch;
}
